import React from "react";
import authRoute from "./authRoute";
import operatorRoute from "./operatorRoute";
import customerRoute from "./customerRoute";
import corporationRoute from "./corporationRoute";
import refurbisherRoute from "./refurbisherRoute";
import giftcardControllerRoute from "./giftcardControllerRoute";

export const publicRoutes = [...authRoute, ...corporationRoute];

export const protectedRoutes = [
  {
    key: "home",
    path: "/home",
    component: React.lazy(() => import("views/home/index")),
    authority: [],
  },
  //Landings
  {
    key: "access-denied",
    path: "/access-denied",
    component: React.lazy(() => import("views/landing/AccessDenied")),
    authority: [],
  },
  {
    key: "error",
    path: "/error",
    component: React.lazy(() => import("views/landing/Error")),
    authority: [],
  },
  {
    key: "donation",
    path: "/donation",
    component: React.lazy(() => import("views/landing/Donation")),
    authority: [],
  },
  {
    key: "donate",
    path: "/donation/donate",
    component: React.lazy(() => import("views/Operator/donation")),
    authority: [],
  },
  ...operatorRoute,
  ...customerRoute,
  ...refurbisherRoute,
  ...giftcardControllerRoute,
];
